import produce, { castDraft, } from 'immer';
import { ProjectActionType, } from './actions';
import { initialProjectsState, } from './models';
import { AuthActionType, } from '../authState/actions';
const projectsByIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case ProjectActionType.SET_PROJECTS:
            return produce(currentState, (draft) => {
                const actualAction = action;
                // add/replace new projects to the currentState
                actualAction.projects.forEach((project) => {
                    draft[project.id] = castDraft(project);
                });
            });
        case ProjectActionType.SET_PROJECT:
            return produce(currentState, (draft) => {
                const actualAction = action;
                // add/replace new project to the currentState
                draft[actualAction.project.id] = castDraft(actualAction.project);
            });
        default:
            return currentState;
    }
};
const allProjectIdsReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case ProjectActionType.SET_PROJECTS:
            return produce(currentState, () => {
                const actualAction = action;
                // convert the list of actualAction.projects to an Array of project ids and update the currentState with the new
                // list. NOTE: only need to update the currentState if NOT both of them are empty. If both of them are empty,
                // do not need to run this or else it will replace the currentState with a NEW empty array which cause unnecessary
                // UI re-render.
                if (actualAction.projects.length !== 0 || !currentState || currentState.length !== 0) {
                    return actualAction.projects.map((project) => {
                        return project.id;
                    });
                }
                return currentState;
            });
        default:
            return currentState;
    }
};
const statisticsByProjectIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case ProjectActionType.SET_PROJECT_STATISTICS:
            return produce(currentState, (draft) => {
                const actualAction = action;
                draft[actualAction.projectId] = actualAction.statistics;
            });
        default:
            return currentState;
    }
};
export const projectsStateReducer = (currentState, action) => {
    if (action.type === AuthActionType.LOGOUT_AGENT) {
        // clear projects data when user logout
        return initialProjectsState;
    }
    return produce(currentState, (draft) => {
        draft.projectsById = castDraft(projectsByIdReducer(currentState.projectsById, action));
        draft.allProjectIds = castDraft(allProjectIdsReducer(currentState.allProjectIds, action));
        draft.statisticsByProjectId = statisticsByProjectIdReducer(currentState.statisticsByProjectId, action);
    });
};
